import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react"

const NOTIFICATION_VISIBLE_SECONDS = 3

const NotificationsContext = createContext()

const useNotifications = () => {
  const context = useContext(NotificationsContext)

  if (!context) {
    throw new Error(
      "You need a NotificationsProvider component to expose NotificationsContext",
    )
  }

  return context
}

const NotificationsProvider = (props) => {
  const [messages, setMessages] = useState([])

  const showNotification = useCallback(
    ({ message, notificationType = "success" }) => {
      setMessages((state) => [...state, { message, notificationType }])
    },
    [setMessages],
  )

  const hideNotification = useCallback(() => {
    setMessages(messages.splice(1))
  }, [messages, setMessages])

  useEffect(() => {
    if (messages.length) {
      const timer = setTimeout(() => {
        hideNotification()
      }, NOTIFICATION_VISIBLE_SECONDS * 1000)

      return () => clearTimeout(timer)
    }
  }, [messages, hideNotification])

  const value = useMemo(
    () => ({
      messages,
      showNotification,
      hideNotification,
    }),
    [messages, showNotification, hideNotification],
  )

  return <NotificationsContext.Provider value={value} {...props} />
}

export { NotificationsProvider, useNotifications }
